import { ValueObject, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class InstrumentSearchCriteria extends ValueObject {

    public searchCriteria: string = "";
}